(function(window, document) {
  'use strict';

  mint.on('documentLoaded', function() {

    const scrollLock = mint.components.scrollLock();
    const offCanvasSwitch = document.querySelector('.page-header__offcanvas-switch');
    const offCanvasContainer = document.querySelector('.page-header__offcanvas');
    const offCanvasAriaHidden = function() {
      if(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navigation-mobile-enabled')) === 1) {
        if(offCanvasContainer.hasAttribute('aria-hidden') === false) {
          offCanvasContainer.setAttribute('aria-hidden', true);
        }
      } else {
        offCanvasContainer.removeAttribute('aria-hidden');
      }
    }

    // Plugin-Aufruf
    const offCanvasSwitchInstance = mint.components.switchButton(offCanvasSwitch, {
      activateCssClass: 'page-header__offcanvas-switch--activate',
      activeCssClass: 'page-header__offcanvas-switch--activated',
      deactivateCssClass: 'page-header__offcanvas-switch--deactivate',
      targetActivateCssClass: 'page-header__offcanvas--open',
      targetActiveCssClass: 'page-header__offcanvas--opened',
      targetDeactivateCssClass: 'page-header__offcanvas--close',
      backdrop: true,
      backdropCssClassModifier: 'page-header-offcanvas'
    });

    // Setzen von (Aria-) Attributen abhaengig von der Aufloesung
    offCanvasAriaHidden();
    window.addEventListener('resize', offCanvasAriaHidden);

    // Aktivierung
    offCanvasSwitch.addEventListener('switch-button.activate', function(event) {
      scrollLock.activate();

      setTimeout(function() {
        event.detail.targetElement.classList.add('page-header__offcanvas--opened');
      }, 0);
    });

    // Deaktivierung
    offCanvasSwitch.addEventListener('switch-button.deactivated', function(event) {
      scrollLock.deactivate();
    });
  });
})(window, document);
